module.exports = __webpack_public_path__ + "img/41.9af2d915.jpg";